export const config = {
  url: "https://docs.google.com/spreadsheets/d/e/2PACX-1vRlsMvY7HIL_6VpoaVHxW4WdgJMwfX2YeGrIvU_I3wzUT0cLFOFLIw_y0WQ4lKiHdz36nnV46s4JipH/pub?gid=0&single=true&output=csv",
  // title: "University Libraries Grants and Awards",
  // description: "A listing of all of the publications by Virginia Tech employees over the last 3 years",
  searchFields: ["Start Date", "End Date", "Person(s) involved", "Grant/Award Title", "Dollar amount", "Organization"],
  headers: [
    {
      key: "Start Date",
      value: "Start Date",
      width: "125px",
    },
    {
        key: "End Date",
        value: "End Date",
        width: "125px",
    },
    {
        key: "Person(s) involved",
        value: "Person(s) involved",
        minWidth: "200px",
    },
    {
        key: "Grant/Award Title",
        value: "Grant/Award Title",
        minWidth: "350px",
    },
    {
        key: "Dollar amount",
        value: "Dollar amount",
        width: "100px",
    },
    {
        key: "Organization",
        value: "Organization",
        minWidth: "250px",
    },
  ],
  link: false,
};
